const data = {
  title: "Floor 4-2",
  musicTrack: "MUSIC_WORLD4",
  theme: "GRAY",
  tilesWidth: 11,
  tilesHeight: 13,
  placements: [
    {
      type: "HERO_SPAWN",
      x: 2,
      y: 2
    },
    {
      type: "PLACEMENT_TYPE_GOAL",
      x: 10,
      y: 2
    },
    {
      type: "WALL",
      x: 3,
      y: 4
    },
    {
      type: "WALL",
      x: 4,
      y: 4
    },
    {
      type: "WALL",
      x: 5,
      y: 4
    },
    {
      type: "WALL",
      x: 6,
      y: 4
    },
    {
      type: "WALL",
      x: 7,
      y: 4
    },
    {
      type: "WALL",
      x: 8,
      y: 4
    },
    {
      type: "WALL",
      x: 9,
      y: 4
    },
    {
      type: "WALL",
      x: 4,
      y: 8
    },
    {
      type: "WALL",
      x: 5,
      y: 8
    },
    {
      type: "WALL",
      x: 7,
      y: 8
    },
    {
      type: "WALL",
      x: 8,
      y: 8
    },
    {
      type: "WALL",
      x: 9,
      y: 8
    },
    {
      type: "ENEMY_SPAWN",
      x: 6,
      y: 5,
      enemyType: "ROAMING_ENEMY"
    },
    {
      type: "ENEMY_SPAWN",
      x: 5,
      y: 5,
      enemyType: "ROAMING_ENEMY"
    },
    {
      type: "ENEMY_SPAWN",
      x: 5,
      y: 6,
      enemyType: "ROAMING_ENEMY"
    },
    {
      type: "ENEMY_SPAWN",
      x: 5,
      y: 7,
      enemyType: "ROAMING_ENEMY"
    },
    {
      type: "ENEMY_SPAWN",
      x: 6,
      y: 7,
      enemyType: "ROAMING_ENEMY"
    },
    {
      type: "ENEMY_SPAWN",
      x: 7,
      y: 7,
      enemyType: "ROAMING_ENEMY"
    },
    {
      type: "ENEMY_SPAWN",
      x: 7,
      y: 6,
      enemyType: "ROAMING_ENEMY"
    },
    {
      type: "ENEMY_SPAWN",
      x: 7,
      y: 5,
      enemyType: "ROAMING_ENEMY"
    },
    {
      type: "WALL",
      x: 1,
      y: 4
    },
    {
      type: "WALL",
      x: 8,
      y: 1
    },
    {
      type: "WALL",
      x: 8,
      y: 3
    },
    {
      type: "WALL",
      x: 4,
      y: 1
    },
    {
      type: "WALL",
      x: 4,
      y: 3
    },
    {
      type: "WALL",
      x: 4,
      y: 7
    },
    {
      type: "WALL",
      x: 6,
      y: 8
    },
    {
      type: "WALL",
      x: 8,
      y: 7
    },
    {
      type: "WALL",
      x: 8,
      y: 5
    },
    {
      type: "WALL",
      x: 4,
      y: 5
    },
    {
      type: "LOCK",
      x: 8,
      y: 6,
      color: "BLUE"
    },
    {
      type: "WALL",
      x: 2,
      y: 8
    },
    {
      type: "WALL",
      x: 1,
      y: 8
    },
    {
      type: "KEY",
      x: 2,
      y: 6,
      color: "BLUE"
    },
    {
      type: "WALL",
      x: 10,
      y: 4
    },
    {
      type: "KEY",
      x: 10,
      y: 6,
      color: "GREEN"
    },
    {
      type: "WALL",
      x: 10,
      y: 8
    },
    {
      type: "CONVEYOR",
      x: 2,
      y: 11,
      direction: "LEFT"
    },
    {
      type: "CONVEYOR",
      x: 3,
      y: 10,
      direction: "UP"
    },
    {
      type: "CONVEYOR",
      x: 3,
      y: 12,
      direction: "DOWN"
    },
    {
      type: "CONVEYOR",
      x: 4,
      y: 11,
      direction: "RIGHT"
    },
    {
      type: "TELEPORT",
      x: 6,
      y: 2
    },
    {
      type: "TELEPORT",
      x: 6,
      y: 6
    },
    {
      type: "TELEPORT",
      x: 3,
      y: 11
    },
    {
      type: "WALL",
      x: 3,
      y: 8
    },
    {
      type: "WALL",
      x: 11,
      y: 8
    },
    {
      type: "WALL",
      x: 11,
      y: 4
    },
    {
      type: "WALL",
      x: 4,
      y: 10
    },
    {
      type: "WALL",
      x: 2,
      y: 10
    },
    {
      type: "WALL",
      x: 2,
      y: 12
    },
    {
      type: "WALL",
      x: 4,
      y: 12
    },
    {
      type: "TELEPORT",
      x: 9,
      y: 11
    },
    {
      type: "LOCK",
      x: 9,
      y: 10,
      color: "GREEN"
    },
    {
      type: "LOCK",
      x: 8,
      y: 11,
      color: "GREEN"
    },
    {
      type: "LOCK",
      x: 10,
      y: 11,
      color: "GREEN"
    },
    {
      type: "WALL",
      x: 8,
      y: 10
    },
    {
      type: "WALL",
      x: 10,
      y: 10
    },
    {
      type: "WALL",
      x: 8,
      y: 12
    },
    {
      type: "WALL",
      x: 10,
      y: 12
    },
    {
      type: "LOCK",
      x: 9,
      y: 12,
      color: "GREEN"
    },
    {
      type: "LOCK",
      x: 8,
      y: 2,
      color: "GREEN"
    },
    {
      type: "WALL",
      x: 4,
      y: 6
    }
  ]
};

export default data;
